




import Vue from 'vue';
// import GErrorIe from '@/components/Pages/GErrorIe.vue';

export default Vue.extend({
  name: 'error-ie',
  // components: {
  //   GErrorIe,
  // },
});
